import { render, staticRenderFns } from "./RencamSchedeMorteCaricamentoCsvList.vue?vue&type=template&id=650fef29"
import script from "./RencamSchedeMorteCaricamentoCsvList.vue?vue&type=script&lang=js"
export * from "./RencamSchedeMorteCaricamentoCsvList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports